module.exports = "/_next/static/images/William_Old-4e0dd290e2dc7363a721beca47fb6a9e.webp";